export const extractDescriptorName = (descriptorHost: string): string => {
  const DESCRIPTOR_REGEX = /^(www\d?\.)?(?<descriptor>[^.]+)/

  return descriptorHost.match(DESCRIPTOR_REGEX)?.groups?.descriptor ?? ''
}
